(function () {
  var section = document.querySelector('[data-im-section]');
  if (!section) return;

  /* ExtraLife 2026-09-02: міст до ES-модуля @shopify/events. Класичний скрипт не може
     робити import() напряму — мініфікатор Shopify CDN переписує його на require() і
     код падає. Тому підключаємо крихітний inline-модуль, який виставляє клас події
     у window.__elCartEvents (import map теми резолвить bare-specifier). */
  if (!window.__elCartEvents && !document.getElementById('el-cart-events-bridge')) {
    var elBridge = document.createElement('script');
    elBridge.type = 'module';
    elBridge.id = 'el-cart-events-bridge';
    elBridge.textContent = "import { CartLinesUpdateEvent } from '@shopify/events'; window.__elCartEvents = { CartLinesUpdateEvent: CartLinesUpdateEvent };";
    document.head.appendChild(elBridge);
  }

  /* ══ bundle rows: independent qty steppers, multi-item add-to-cart ══
     Each row is its own variant with its own quantity (0 = not included).
     "Додати в кошик" collects every row with qty > 0 into one
     /cart/add.js call with an items[] array — native <form> submission
     can only ever carry a single variant, so this always goes through JS. ══ */
  var packs = section.querySelectorAll('[data-im-pack]');
  var stickyPriceEl = section.querySelector('[data-im-sticky-price]');
  var brandPriceEl = section.querySelector('[data-im-brand-price]');
  var brandPerSubEl = section.querySelector('[data-im-brand-persub]');
  var brandOldWrapEl = section.querySelector('[data-im-brand-oldwrap]');
  var brandOldPriceEl = section.querySelector('[data-im-brand-oldprice]');
  var finalPriceEls = section.querySelectorAll('[data-im-final-price]');
  var finalOldWrapEl = section.querySelector('[data-im-final-oldwrap]');
  var finalOldPriceEl = section.querySelector('[data-im-final-oldprice]');
  var finalSaveWrapEl = section.querySelector('[data-im-final-savewrap]');
  var finalSaveEl = section.querySelector('[data-im-final-save]');
  var nudges = section.querySelectorAll('[data-im-nudge]');
  var ladderPoints = section.querySelectorAll('[data-im-ladder-point]');
  var bundlesWrap = section.querySelector('[data-im-bundles]');
  var mainForm = section.querySelector('[data-im-atc-main]') ? section.querySelector('[data-im-atc-main]').form : null;

  var stickyPriceDefault = stickyPriceEl ? stickyPriceEl.textContent.trim() : '';
  var brandPriceDefault = brandPriceEl ? brandPriceEl.textContent.trim() : '';
  var brandPerSubDefault = brandPerSubEl ? brandPerSubEl.textContent.trim() : '';

  function syncForVariant(variantId) {
    nudges.forEach(function (n) {
      n.hidden = n.getAttribute('data-im-nudge') !== variantId;
    });
    ladderPoints.forEach(function (pt) {
      pt.classList.toggle('im-ladder__point--active', pt.getAttribute('data-im-ladder-point') === variantId);
    });
  }

  function parseMoney(text) {
    var n = parseFloat(String(text || '').replace(/\s/g, '').replace(',', '.').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function formatMoney(n) {
    var rounded = Math.round(n * 100) / 100;
    var str = (rounded % 1 === 0) ? String(rounded) : rounded.toFixed(2).replace(/0$/, '').replace('.', ',');
    return str + ' ₴';
  }

  function refreshTotals() {
    var total = 0;
    var totalOld = 0;
    var lastActiveVariant = null;
    packs.forEach(function (pack) {
      var valueEl = pack.querySelector('[data-im-stepper-value]');
      var qty = valueEl ? (parseInt(valueEl.textContent, 10) || 0) : 0;
      pack.classList.toggle('im-bundle-row--active', qty > 0);
      if (qty > 0) {
        var priceEl = pack.querySelector('[data-im-pack-price]');
        var price = priceEl ? parseMoney(priceEl.textContent) : 0;
        var oldAttr = pack.getAttribute('data-im-pack-oldprice');
        var oldPrice = oldAttr ? parseMoney(oldAttr) : price;
        total += price * qty;
        totalOld += oldPrice * qty;
        lastActiveVariant = pack.getAttribute('data-im-pack-variant-id');
      }
    });

    if (total > 0) {
      var totalText = formatMoney(total);
      if (stickyPriceEl) stickyPriceEl.textContent = totalText;
      if (brandPriceEl) brandPriceEl.textContent = totalText;
      if (finalPriceEls.length) finalPriceEls.forEach(function (el) { el.textContent = totalText; });
      var hasDiscount = totalOld > total;
      if (brandOldWrapEl) {
        if (hasDiscount && brandOldPriceEl) brandOldPriceEl.textContent = formatMoney(totalOld);
        brandOldWrapEl.hidden = !hasDiscount;
      }
      if (finalOldWrapEl) {
        if (hasDiscount && finalOldPriceEl) finalOldPriceEl.textContent = formatMoney(totalOld);
        finalOldWrapEl.hidden = !hasDiscount;
      }
      if (finalSaveWrapEl) {
        if (hasDiscount && finalSaveEl) finalSaveEl.textContent = (totalOld - total).toFixed(0);
        finalSaveWrapEl.hidden = !hasDiscount;
      }
    } else {
      if (stickyPriceEl) stickyPriceEl.textContent = stickyPriceDefault;
      if (brandPriceEl) brandPriceEl.textContent = brandPriceDefault;
      if (brandPerSubEl) brandPerSubEl.textContent = brandPerSubDefault;
      if (brandOldWrapEl) brandOldWrapEl.hidden = true;
      if (finalOldWrapEl) finalOldWrapEl.hidden = true;
      if (finalSaveWrapEl) finalSaveWrapEl.hidden = true;
    }
    syncForVariant(lastActiveVariant);
  }

  packs.forEach(function (pack) {
    var minus = pack.querySelector('[data-im-stepper-minus]');
    var plus = pack.querySelector('[data-im-stepper-plus]');
    var valueEl = pack.querySelector('[data-im-stepper-value]');
    if (!minus || !plus || !valueEl) return;
    function setQty(n) {
      n = Math.max(0, n);
      valueEl.textContent = String(n);
      minus.disabled = n === 0;
      refreshTotals();
    }
    minus.addEventListener('click', function () { setQty((parseInt(valueEl.textContent, 10) || 0) - 1); });
    plus.addEventListener('click', function () { setQty((parseInt(valueEl.textContent, 10) || 0) + 1); });
  });

  /* nudge "Перейти на N →" — bumps that pack's stepper to 1 if it's still at 0 */
  section.querySelectorAll('[data-im-nudge-goto]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-im-nudge-goto');
      var targetPack = section.querySelector('[data-im-pack][data-im-pack-variant-id="' + targetId + '"]');
      if (!targetPack) return;
      var valueEl = targetPack.querySelector('[data-im-stepper-value]');
      var minus = targetPack.querySelector('[data-im-stepper-minus]');
      if (valueEl && (parseInt(valueEl.textContent, 10) || 0) === 0) {
        valueEl.textContent = '1';
        if (minus) minus.disabled = false;
        refreshTotals();
      }
    });
  });

  /* ladder point click scrolls back up to the bundle rows */
  section.querySelectorAll('[data-im-scroll-to-picker]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (bundlesWrap) bundlesWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* main add-to-cart: collect every row with qty > 0 into one items[] call
     (a native form can only carry one variant id, so this always needs JS) */
  if (mainForm) {
    mainForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [];
      packs.forEach(function (pack) {
        var valueEl = pack.querySelector('[data-im-stepper-value]');
        var qty = valueEl ? (parseInt(valueEl.textContent, 10) || 0) : 0;
        if (qty > 0) {
          items.push({ id: parseInt(pack.getAttribute('data-im-pack-variant-id'), 10), quantity: qty });
        }
      });
      var mainBtn2 = section.querySelector('[data-im-atc-main]');
      if (!items.length) {
        if (bundlesWrap) {
          bundlesWrap.classList.add('im-bundles--nudge');
          setTimeout(function () { bundlesWrap.classList.remove('im-bundles--nudge'); }, 600);
          bundlesWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      var originalText = mainBtn2 ? mainBtn2.innerHTML : '';
      if (mainBtn2) { mainBtn2.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (result.ok) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            /* ExtraLife 2026-09-02: не переходимо на /cart — відкриваємо шухляду кошика.
   Диспатчимо той самий CartLinesUpdateEvent, що й рідний product-form теми:
   cart-items-component перемальовує шухляду, header оновлює лічильник,
   cart-drawer-component (auto-open) відкриває її. Фолбек — редірект на /cart. */
Promise.resolve(window.__elCartEvents || Promise.reject(new Error('cart events bridge not loaded'))).then(function (ev) {
  var deferred = ev.CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new ev.CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
    promise: deferred.promise
  }));
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'extralife-pdp', didError: false } });
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
    });
}).catch(function () { window.location.href = '/cart'; })
  .then(function () { if (mainBtn2) { mainBtn2.disabled = false; } });
          } else if (mainBtn2) {
            mainBtn2.textContent = 'Помилка, спробуй ще';
            mainBtn2.disabled = false;
            setTimeout(function () { mainBtn2.innerHTML = originalText; }, 2200);
          }
        })
        .catch(function () {
          if (mainBtn2) {
            mainBtn2.textContent = 'Помилка, спробуй ще';
            mainBtn2.disabled = false;
            setTimeout(function () { mainBtn2.innerHTML = originalText; }, 2200);
          }
        });
    });
  }

  /* ══ sticky bar visibility — IntersectionObserver, NOT a scroll listener ══
     (this theme scrolls an inner .page-wrapper; window.scrollY stays 0, so a
     scroll-position check never fires — watch the main CTA button instead) */
  var mainBtn = section.querySelector('[data-im-atc-main]');
  var stickyBar = section.querySelector('[data-im-sticky]');
  if (mainBtn && stickyBar && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      });
    }, { threshold: 0 });
    io.observe(mainBtn);
  }

  /* ══ gallery (hero carousel, 7 slots) ══ */
  var thumbs = section.querySelectorAll('[data-im-gal-thumb]');
  var slides = section.querySelectorAll('[data-im-gal-slide]');
  var galMainEl = section.querySelector('[data-im-gallery] .im-gallery__main');
  var galIndices = Array.prototype.map.call(slides, function (s) { return s.getAttribute('data-im-gal-slide'); });

  function activateGalSlide(idx) {
    thumbs.forEach(function (t) { t.classList.toggle('im-gallery__thumbbtn--active', t.getAttribute('data-im-gal-thumb') === idx); });
    slides.forEach(function (s) { s.classList.toggle('im-gallery__slide--active', s.getAttribute('data-im-gal-slide') === idx); });
    if (galMainEl) galMainEl.setAttribute('data-light', (idx === '0' || idx === '1') ? '1' : '0');
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      activateGalSlide(thumb.getAttribute('data-im-gal-thumb'));
    });
  });

  var galPrev = section.querySelector('[data-im-gal-prev]');
  var galNext = section.querySelector('[data-im-gal-next]');
  function currentGalIndex() {
    var activeSlide = section.querySelector('[data-im-gal-slide].im-gallery__slide--active');
    var idx = activeSlide ? galIndices.indexOf(activeSlide.getAttribute('data-im-gal-slide')) : 0;
    return idx < 0 ? 0 : idx;
  }
  function goToGalOffset(offset) {
    if (!galIndices.length) return;
    var i = currentGalIndex();
    var nextI = (i + offset + galIndices.length) % galIndices.length;
    activateGalSlide(galIndices[nextI]);
  }
  if (galPrev && galIndices.length) galPrev.addEventListener('click', function () { goToGalOffset(-1); });
  if (galNext && galIndices.length) galNext.addEventListener('click', function () { goToGalOffset(1); });

  /* swipe navigation (mobile: thumbs/arrows hidden there, swipe is the only way) */
  if (galMainEl && galIndices.length > 1) {
    var touchStartX = 0, touchStartY = 0, touchTracking = false;
    galMainEl.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) { touchTracking = false; return; }
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchTracking = true;
    }, { passive: true });
    galMainEl.addEventListener('touchend', function (e) {
      if (!touchTracking) return;
      touchTracking = false;
      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goToGalOffset(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* keyboard arrows when gallery is focused */
  var galRoot = section.querySelector('[data-im-gallery]');
  if (galRoot) {
    galRoot.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goToGalOffset(-1);
      if (e.key === 'ArrowRight') goToGalOffset(1);
    });
  }

  /* ══ FAQ accordion — first item open by default (via [open] in markup);
     close siblings when one opens so only one is expanded at a time ══ */
  var faqItems = section.querySelectorAll('[data-im-faq-item]');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        faqItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  /* ══ testimonials "show more" — 1:1 AfterAlco reviews toggle ══ */
  var moreBtn = section.querySelector('[data-im-reviews-toggle]');
  var extras = section.querySelectorAll('[data-im-review-extra]');
  if (moreBtn && extras.length) {
    var reviewsExpanded = false;
    moreBtn.addEventListener('click', function () {
      reviewsExpanded = !reviewsExpanded;
      extras.forEach(function (el) { el.hidden = !reviewsExpanded; });
      moreBtn.textContent = reviewsExpanded ? 'Сховати відгуки' : 'Показати ще відгуки';
    });
  }

  /* ══ cross-sell quick-add — Shopify Ajax Cart API, no page navigation ══ */
  var xsellForms = section.querySelectorAll('[data-im-xsell-form]');
  xsellForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-im-xsell-addbtn]');
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!idInput) return;
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Додаємо…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!btn) return;
          if (result.ok) {
            btn.textContent = 'Додано ✓';
            btn.setAttribute('data-im-added', '1');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              btn.textContent = originalText;
              btn.removeAttribute('data-im-added');
              btn.disabled = false;
            }, 2200);
          } else {
            btn.textContent = 'Помилка, спробуй ще';
            setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2200);
          }
        })
        .catch(function () {
          if (btn) { btn.textContent = 'Помилка, спробуй ще'; setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2200); }
        });
    });
  });
})();
